import React, { useState, useEffect, useContext } from "react";

import lbl from "../../../data/Labels.json";

import Img from "../../common/Img";

import db from "../../../services/query";
import FabButtons from "./FinanceFabButtons";
import useParityAccess, { useAccessReady } from "../../common/useParityAccess";

import { PopUpContext } from "../../../contexts/popUpContext";

import PastBalanceBtn from "./PastBalanceBtn";
import ReportItemList from "./ReportItemList";
import ReportItemHeader from "../../common/ReportItemHeader";
import DiscountsList from "./FinanceDiscountsList";
import PaymentsList from "./FinancePaymentsList";
import Card from "../../common/Card";
import MainPrintLink from "../../common/MainPrint";

const FinanceProfile = (props) => {
  const { sid } = props.match.params;

  const [activeSem, setSem] = useState(0);
  const [data, updateData] = useState([]);

  const { popUp } = useContext(PopUpContext);
  const can = useParityAccess();
  const ready = useAccessReady();
  const canPrint = !ready || can("print-student-fee-statement");

  useEffect(async () => {
    const ac = new AbortController();
    requestData();
    return () => ac.abort();
  }, [popUp]);

  const requestData = async () => {
    let query = `students/${sid}/fees`;

    await db.getAll(query).then(({ data }) => {
      updateData(data);
    });
  };

  return (
    <React.Fragment>
      <div className="finance-profile-area">
        <div className="std-profile">
          <div className="wrapper">
            <Img src={data?.summary?.student_photo} border={true} />
          </div>
        </div>
        <div className="overall-summary">
          <div className="wrapper">
            <p>{lbl.OverallBalance}</p>
            <h1>{data?.summary?.balance}</h1>
          </div>
        </div>
        <div className="controls">
          <FabButtons cache={sid} />
          {canPrint ? <MainPrintLink path={`student-fee-statement/${sid}`} /> : null}
        </div>
      </div>
      <div className="finance-report-area">
        <div className="report-container _75-per">
          <ReportItemHeader title={lbl.Details} />
          <div className="report-card-area">
            <Card
              title={lbl.SemesterBalance}
              data={data?.data && data.data[activeSem]?.balance}
            />
            <Card
              title={lbl.Fees}
              data={data?.data && data.data[activeSem]?.fee}
            />
          </div>
          <div className="report-table-area">
            <DiscountsList activeSem={data?.data && data.data[activeSem]} />
            <PaymentsList activeSem={data?.data && data.data[activeSem]} />
          </div>
        </div>
        <div className="report-container _25-per">
          <ReportItemHeader title={lbl.Semester} />
          <ReportItemList data={data} setSem={setSem} activeSem={activeSem} />
          <PastBalanceBtn data={data} cache={sid} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FinanceProfile;
